import { z } from 'zod';

export type PageSchema<T extends z.ZodSchema> = z.infer<ReturnType<typeof pageSchemaOf<T>>>;

export function pageSchemaOf<ItemType extends z.ZodSchema>(itemSchema: ItemType) {
  return z.object({
    page: z.number(),
    size: z.number(),
    total: z.number(),
    num_pages: z.number(),
    items: itemSchema,
  });
}
